
import { useQuery } from "@tanstack/react-query";
import { Form2Payload } from "../../pages/app/provider/scheduling/appointment/encounter/encounter-constant";
import {
    EncounterSummaryControllerApi
} from "../../services";
import {
    getConfigObject,
    useBaseContent
} from "../../utils/utils";

interface Props {
    appointmentUuid?: string;
    xTENANTID?: string;
    enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useEncounterSummeryV2 = ({
    appointmentUuid,
    xTENANTID,
    enabled = true,
}: Props): useBaseContent<Form2Payload> => {

    return useQuery({
        queryKey: [
            "encounter-summery-v2",
            appointmentUuid,
            xTENANTID,
        ],
        refetchOnWindowFocus: false,

        enabled: !!appointmentUuid && enabled,
        staleTime: 30_000,
        queryFn: async () =>
            await new EncounterSummaryControllerApi(getConfigObject())
                .getEncounterSummarySnapshot(
                    appointmentUuid!,
                    xTENANTID // xTENANTID
                )
                .then((res) => res?.data),
    });
};
